import { User } from 'resources/types'
import { queryClient } from 'main'
import { getSelectedCompanyId } from './selectedCompanyAccess'
import { QK } from 'shared/hooks/useCurrentUser'


export function getCurrentUser(): User | undefined {
	const companyId = getSelectedCompanyId()
	if (!companyId) return
	return queryClient.getQueryData<User>(QK(companyId))
}

export function setCurrentUser(user: User | undefined) {
	const companyId = getSelectedCompanyId()
	if (!companyId) return
	queryClient.setQueryData(QK(companyId), user)
}
